import {
  Link as UiLink,
  type LinkProps as UiLinkProps,
} from '@veraclins-dev/ui';
import {
  Link as RouterLink,
  type LinkProps as RouterLinkProps,
} from 'react-router';

export type AppLinkProps = Omit<UiLinkProps<typeof RouterLink>, 'component'>;

export function AppLink({
  className,
  type = 'link',
  underline = 'none',
  ...props
}: AppLinkProps) {
  const handleClick: RouterLinkProps['onClick'] = (event) => {
    props.onClick?.(event);

    if (!props.onClick) {
      event.stopPropagation();
    }
  };

  return (
    <UiLink
      component={RouterLink}
      type={type}
      underline={underline}
      {...props}
      maxW="full"
      className={className}
      onClick={handleClick}
    />
  );
}

export type AppExternalLinkProps = UiLinkProps<'a'>;

export function AppExternalLink({
  className,
  underline = 'none',
  ...props
}: AppExternalLinkProps) {
  return (
    <UiLink
      underline={underline}
      {...props}
      maxW="full"
      className={className}
    />
  );
}
